import React from "react";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from '@material-ui/core/Collapse';
import { List } from "@material-ui/core";
import { apollo_useStyles } from "./Apollo_styles";
import { Link } from "react-router-dom";
import moment from "moment";

type menuBarDataColor = "#4B4B4B" | "#B1B1B1";

export type MenuBarData = {
  display: boolean,            // 表示有無 true: 表示, false: 非表示
  type: number,                // クリック時の挙動 1: リンク先へ遷移, 2: メニュー選択モーダル表示, 3: プルダウンメニューを表示
  link: string,                // 遷移先URL
  title: string,               // メニュー名
  img: string,                 // アイコン画像パス
  subMenuList: SubMenuData[],  // プルダウンメニューリスト
  color: menuBarDataColor,     // 文字の色
  tooltipTitle?: string,       // ツールチップのタイトル（メニュー名以外にツールチップに表示したい時に使用）
}

type SubMenuData = {
  display: boolean,            // 表示有無 true: 表示, false: 非表示
  link: string,                // 遷移先URL
  title: string,               // メニュー名
  img?: string,
  color: menuBarDataColor,
}

export function MenuBar(props: { data: MenuBarData, open: boolean }) {
  const { data, open } = props;

  return (
    <React.Fragment>
      <ListItem button>
        <Tooltip title={data.tooltipTitle ?? data.title} placement="bottom-end">
          <ListItemIcon>
            <img src={data.img} alt="home" height="auto" width="25" />
          </ListItemIcon>
        </Tooltip>
        <ListItemText
          primary={data.title}
          style={{ whiteSpace: open ? "pre-line" : "nowrap", color: data.color }}
          primaryTypographyProps={{ style: { fontSize: data.title === "審査結果ダウンロード\n（パフォーマンス広告）" ? 15 : 16 } }}
        />
      </ListItem>
    </React.Fragment>
  );
}

function SubMenuBar(props: { data: SubMenuData }) {
  const classes = apollo_useStyles();
  const { data } = props;

  return (
    <React.Fragment>
      <ListItem button className={classes.nested}>
        <ListItemIcon>
          <ListItemText primary={data.title} primaryTypographyProps={{ style: { whiteSpace: "pre-line", lineHeight: 1.3, color: data.color } }} />
          {data.img && (
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", alignSelf: "stretch", padding: "8px 0" }}>
              <img
                src={data.img}
                alt="icon"
                style={{ height: "100%", width: "auto", marginLeft: 8, display: "block" }}
              />
            </div>
          )}
        </ListItemIcon>
      </ListItem>
    </React.Fragment>
  );
}

export function MenuBarCollapse(props: { data: MenuBarData, open: boolean }) {
  const classes = apollo_useStyles();
  const { data, open } = props;
  const [openSub, setOpenSub] = React.useState(true);

  const handleDrawerToggle = () => {
    setOpenSub(!openSub);
  };

  return (
    <React.Fragment>
      <div onClick={handleDrawerToggle}>
        <MenuBar data={data} open={open} />
      </div>
      <Collapse in={openSub && open} timeout="auto" unmountOnExit>
        {data.subMenuList?.map((subData, idx) => (
          subData.display &&
          <List component="div" disablePadding key={idx}>
            <Link to={subData.link} className={classes.link}>
              <SubMenuBar data={subData} />
            </Link>
          </List>
        ))}
      </Collapse>
    </React.Fragment>
  );
}
